/*

  Docs: https://github.com/akiran/react-slick

*/

import React, {Component} from 'react'
import ReactDOM from "react-dom";
import Slider from "react-slick";

import './index.css'

class CarouselGallery extends Component {

  render () {

    let settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode : false,
      //centerPadding: '30px'
    };

    if(this.props.settings) settings = {...settings,...this.props.settings};

    return (

      <div>
        <div className="CarouselGallery">
        <Slider {...settings} afterChange={this.props.onChange} ref={this.props.api}>
          {this.props.children}
        </Slider>
        </div>
      </div>
    )
  }
}

export default CarouselGallery



// WEBPACK FOOTER //
// ./src/js/components/CarouselGallery/CarouselGallery.jsx